import gql from 'graphql-tag';

export const GET_MENSAJES_RECLAMACION = gql(`
    query listaMensajeReclamacion($criteria: ItemCriteriaInput) {
        listaMensajeReclamacion(criteria: $criteria) {
            firstElement
            totalElements
            results{
                id
                mensaje
                fecha
                reclamacion{
                    token
                }
                usuario{
                    uuid
                    nombre
                    apellidos
                    tipo
                }
                archivos{
                    id
                    filename
                }
            }
        }
    }
`);

export const ALTA_MENSAJE_RECLAMACION = gql(`
    mutation altaMensajeReclamacion($altaMensajeReclamacionRequest: AltaMensajeReclamacionRequestInput) {
        altaMensajeReclamacion(altaMensajeReclamacionRequest: $altaMensajeReclamacionRequest) {
            id
            reclamacion{
                token
            }
            usuario{
                nombre
                apellidos
            }
            archivos{
                filename
                id
            }
            mensaje
            fecha
        }
    }
`);

export const GET_RECLAMACION = gql(`
   query reclamacion($token: String){
      reclamacion(token:$token){
         uuid     
      }
   }
`);

